import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Input, Table } from "antd";
import "antd/dist/antd.css";
import { itemRender, onShowSizeChange } from "../../paginationfunction";
import "../../antdstyle.css";
import Select from "react-select";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";

import { SearchOutlined } from "@ant-design/icons";
import { HrApi } from "../../../initialpage/hooks/HrApi";
import useAuth from "../../../initialpage/hooks/useAuth";
const Designation = () => {
  const [data, setData] = useState([]);
  const { searchFunction } = useAuth();
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchDesignation, setSearchDesignation] = useState("");
  const [loadUpdate, setLoadUpdate] = useState(false);
  const [IndividualDesignation, setIndividualDesignation] = useState({});
  const [gradeData, setGradeData] = useState([]);
  const [gradeCategory, setGradeCategory] = useState();

  // React Hook Form
  const {
    register: register,
    reset: reset,
    formState: { errors: errors },
    handleSubmit: handleSubmit,
  } = useForm();
  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();

  // get designation data

  useEffect(() => {
    getUsers();
  }, [searchDesignation, loadUpdate]);
  const getUsers = () => {
    fetch(`${HrApi}/hr/setting/get/designation`)
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Server responds with error!");
        }
        return res.json();
      })
      .then(
        (data) => {
          const getSignData = data.items;
          console.log(getSignData);
          const searchData = searchFunction(
            getSignData,
            searchDesignation,
            "designation_id",
            "designation",
            "grade_id",
          );
          setData(searchData);
          setLoadUpdate(false);
          setIsLoading(true);
        },
        (err) => {
          const mute = err;
          setHasError(true);
          setIsLoading(true);
        }
      );
  };
  // post Method
  const onSubmitPost = (data1) => {
    axios({
      method: "post",
      url: `${HrApi}/hr/setting/post/designation`,
      data: {
        DESIGNATION: data1.designation,
        GRADE_ID: data1.grade_id,
      },
      headers: { Authorization: "Bearer ..." },
    }).then((res) => {
      if (res.data?.data.error == null) {
        setLoadUpdate(true);
        swal({
          title: "Thank you",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        reset();
        getUsers();
        window.$("#add_designation").modal("hide");
      }
    });
  };

  // // PUT METHOD
  const [getDesignation, setGetDesignation] = useState([]);
  const [getId, setGetId] = useState(null);

  const onSubmitUpdate = (data1) => {
    if (data1.designation) {
      data1.designation = data1.designation;
    } else {
      data1.designation = IndividualDesignation.designation;
    }
    if (data1.grade_id) {
      data1.grade_id = data1.grade_id;
    } else {
      data1.grade_id = IndividualDesignation.grade_id;
    }

    // PUT METHOD
    axios({
      method: "put",

      headers: {
        DESIGNATION_ID: getId,
      },
      url: `${HrApi}/hr/setting/put/designation`,
      data: data1,
    }).then((res) => {
      if (res.data.error == null) {
        setLoadUpdate(true);
        swal({
          title: "Thank you",
          text: "Successfully Updated",
          icon: "success",
          button: "Ok",
        });
        reset1();
        getUsers();
        window.$("#edit_designation").modal("hide");
      }
    });
  };

  const handleUpdate = (updateId) => {
    //
    let filterUniqueId = data?.filter((row) => row.designation_id == updateId);
    console.log("filterUniqueId", filterUniqueId[0]);
    setIndividualDesignation(filterUniqueId[0]);
    setGetId(updateId);
  };
  //

  // Delete API
  const deleteButtonHandler = (Id) => {
    //
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = `${HrApi}/hr/setting/delete/designation`;
        fetch(url, {
          method: "DELETE",
          headers: {
            DESIGNATION_ID: Id,
          },
        }).then((item) => {
          getUsers();
        });
        swal("Poof! Your imaginary file has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  const columns = [
    {
      title: "DESIGNATION ID",
      dataIndex: "designation_id",
    },
    {
      title: "DESIGNATION",
      dataIndex: "designation",
    },
    {
      title: "GRADE",
      dataIndex: "grade_id",
    },

    {
      title: "Action",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-right">
          <a
            href="#"
            className="action-icon dropdown-toggle"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </a>
          <div className="dropdown-menu dropdown-menu-right">
            <a
              className="dropdown-item"
              href="#"
              data-toggle="modal"
              data-target="#edit_designation"
              onClick={() => {
                handleUpdate(record.designation_id);
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </a>
            <a
              className="dropdown-item"
              href="#"
              onClick={() => {
                deleteButtonHandler(record.designation_id);
              }}
            >
              <i className="fa fa-trash-o m-r-5" /> Delete
            </a>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <Helmet>
          <title>Designations - HR</title>
          <meta name="description" content="Login page" />
        </Helmet>
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Designations</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/app/main/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Designations</li>
                </ul>
              </div>
              <div className="col-auto float-right ml-auto">
                <a
                  href="#"
                  className="btn buttonColor"
                  data-toggle="modal"
                  data-target="#add_designation"
                >
                  <i className="fa fa-plus" /> Add New Designation
                </a>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row  mb-4 ps-2">
            <input
              onChange={(e) => {
                setSearchDesignation(e.target.value);
              }}
              className="form-control w-25 shadow py-4"
              type="text"
              placeholder="Search Here"
            />
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  className="table-striped"
                  pagination={{
                    total: data?.length,
                    showTotal: (total, range) =>
                      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                    showSizeChanger: true,
                    onShowSizeChange: onShowSizeChange,
                    itemRender: itemRender,
                  }}
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  bordered
                  dataSource={data}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
        {/* Add Designation Modal */}

        <div
          id="add_designation"
          className="modal custom-modal fade"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add new Designation</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                </button>
              </div>
              <div className="modal-body text-start">
                <form onSubmit={handleSubmit(onSubmitPost)}>
                  <div className="row">
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput14"
                        className="form-label fw-bold small"
                      >
                        Designation title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput14"
                        placeholder="Enter Designation title"
                        {...register("designation")}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput14"
                        className="form-label fw-bold small"
                      >
                        Grade
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput14"
                        placeholder="Enter Grade"
                        {...register("grade_id")}
                      />
                    </div>
                  </div>

                  <div className="submit-section">
                    <button
                      type="submit"
                      className="btn buttonColor px-5 py-2 rounded"
                    >
                      Add
                    </button>

                    <button
                      type="button"
                      className="btn buttonColor px-5 ms-1 py-2 rounded"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Designation Modal */}

        <div
          id="edit_designation"
          className="modal custom-modal fade"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Designation</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                </button>
              </div>
              <div className="modal-body text-start">
                <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                  <div className="row">
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput14"
                        className="form-label fw-bold small"
                      >
                        Designation title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput14"
                        defaultValue={IndividualDesignation.designation}
                        {...register1("designation")}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput14"
                        className="form-label fw-bold small"
                      >
                        Grade
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput14"
                        defaultValue={IndividualDesignation.grade_id}
                        {...register1("grade_id")}
                      />
                    </div>
                  </div>

                  <div className="submit-section">
                    <button
                      type="submit"
                      className="btn buttonColor px-5 py-2 rounded"
                    >
                      Add
                    </button>

                    <button
                      type="button"
                      className="btn buttonColor px-5 ms-1 py-2 rounded"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Designation;
